import { Link } from "react-router-dom";
import { GENRES } from "@/lib/categories";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div className="lg:pr-6">
            <Link to="/" className="flex items-center gap-2.5" aria-label="免费看大片首页">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-50">
                免费看大片
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400">
              汇集最新热门电影与经典大片，覆盖动作、科幻、悬疑、爱情等十余种类型，提供清晰完整的影片资料与流畅的浏览体验。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-400">
              <i className="ri-mail-line text-primary-300" />
              service@mianfeikandapian.com
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100">
              <Link to="/category/全部" className="transition-colors hover:text-primary-300">
                热门分类
              </Link>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-y-2.5">
              {GENRES.slice(0, 8).map((genre) => (
                <li key={genre.name}>
                  <Link
                    to={`/category/${encodeURIComponent(genre.name)}`}
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                  >
                    {genre.name}片
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100">
              <Link to="/" className="transition-colors hover:text-primary-300">
                快速导航
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <Link
                  to="/category/全部"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                >
                  全部影片
                </Link>
              </li>
              <li>
                <Link
                  to="/category/全部?sort=hot"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                >
                  热门榜单
                </Link>
              </li>
              <li>
                <Link
                  to="/category/全部?sort=rating"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                >
                  高分好评
                </Link>
              </li>
              <li>
                <Link
                  to="/favorites"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                >
                  我的收藏
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100">
              <Link to="/about" className="transition-colors hover:text-primary-300">
                关于与帮助
              </Link>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                >
                  网站介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about#instructions"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                >
                  使用说明
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                >
                  意见反馈
                </Link>
              </li>
              <li>
                <Link
                  to="/about#copyright"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                >
                  版权声明
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/60 px-4 py-5 md:px-8">
        <div className="mx-auto flex w-full max-w-[1440px] flex-col items-start justify-between gap-2 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>© 2026 免费看大片 · 保留所有权利</p>
          <p className="text-foreground-600">
            本站影片信息为演示内容，播放功能仅作界面展示，不提供真实影片资源。
          </p>
        </div>
      </div>
    </footer>
  );
}